import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-toastify/dist/ReactToastify.css';
import './App.css'
import RouterContainer from './RouterContainer';
import { ToastContainer } from 'react-toastify';
export default function App() {
  return (
    <>
      <RouterContainer />
      <ToastContainer />
    </>
  )
}
